interface IWorkbookError extends IError {
    workbookTabId: number;
    widgetId: number;
}

class WorkbookError extends ErrorBase implements IWorkbookError {
    get workbookTab() {
        if (this.workbookTabName) {
            return `${this.workbookTabId} - ${this.workbookTabName}`;
        }
        return this.workbookTabId;
    }
    workbookTabId: number;
    workbookTabName: string;

    get widget() {
        if (this.widgetName) {
            return `${this.widgetId} - ${this.widgetName}`;
        }
        return this.widgetId;
    }
    widgetId: number;
    widgetName: string;

    constructor(data: IWorkbookError) {
        super(data);
        this.type = ErrorTypeEnum.Workbook;

        this.workbookTabId = data.workbookTabId ?? null;
        let tab = workbook?.workbookConfig?.tabs()?.find(x => x.id() === this.workbookTabId);
        if (this.workbookTabId) {
            this.workbookTabName = tab?.name() ?? "";
        }

        this.widgetId = data.widgetId ?? null;
        if (this.widgetId && tab?.isDashboardLoaded) {
            this.widgetName = tab?.dashboard?.widgets()?.find(x => x.id() === this.widgetId)?.name() ?? "";
        }
    }

    toString(): string {
        let message = `Date: ${this.datetime}\nMapping: ${workbook.workbookConfig.mappingName}\nWorkbook: ${workbook.workbookConfig.workbookName}`;
        if (this.workbookTab) {
            message += `\nTab: ${this.workbookTab}`
        }

        if (this.widget) {
            message += `\nWidget: ${this.widget}`
        }

        let errorMessage = this.errorMessage;
        if (this.userMessage && this.userMessage !== errorMessage) {
            errorMessage = `${this.userMessage}\n\n----------------------------------------\n\n${errorMessage}`;
        }
        if (errorMessage) {
            message += `\nMessage: ${errorMessage}`
        }

        if (this.parameters) {
            message += `\nParameters: ${this.parameters}`
        }

        if (this.stackTrace) {
            message += `\nCall Stack: ${this.stackTrace}`
        }

        return message;
    }
}